import React from 'react';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { Link } from 'react-router-dom';
import { Loader } from '@mantine/core';
import { ButtonProps } from './';

const Button: React.FC<ButtonProps> = ({
  variant = 'solid',
  linkTo,
  size = 'sm',
  children,
  className,
  disabled,
  loading,
  full,
  styles,
  type = 'button',
  leftSection,
  rightSection,
  onClick,
  onMouseEnter,
  onMouseLeave
}) => {
  const classes = `beelajar-button ${variant} ${size} ${
    full ? 'full' : ''
  } ${className} ${disabled ? 'disabled' : ''}`;

  if (variant === 'link') {
    return (
      <Link className={`beelajar-button ${variant}`} style={styles} to={linkTo}>
        {leftSection}
        {children}
        {rightSection}
      </Link>
    );
  }

  return (
    <button
      className={classes}
      style={styles}
      type={type}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {loading && (
        <Loader
          size={16}
          color={
            variant === 'error' || variant === 'solid'
              ? 'rgba(255, 255, 255, 1)'
              : 'grape'
          }
          mr={10}
        />
      )}
      {leftSection}
      {children}
      {rightSection}
    </button>
  );
};

export default Button;
